module.exports = __webpack_public_path__ + "static/media/samfunnsdialog_illustration.805f42b9.png";